import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as go from 'gojs';
import { BehaviorSubject, Observable } from 'rxjs';
import { GoJsContextMenuModel, GoJsContextMenuOptions } from './gojs-context-menu.model';

@UntilDestroy()
@Injectable()
export class GojsContextMenuService {
  private readonly contextMenuSubject$ = new BehaviorSubject<GoJsContextMenuModel>({
    open: false,
  });

  public readonly contextMenu$: Observable<GoJsContextMenuModel> = this.contextMenuSubject$.pipe(untilDestroyed(this));

  show(options: GoJsContextMenuOptions, _diagram: go.Diagram) {
    this.contextMenuSubject$.next({
      open: true,
      options,
    });
  }

  hide() {
    this.contextMenuSubject$.next({
      open: false,
    });
  }
}
